import React, { Fragment } from 'react';
import * as utilities from "../../utilities/utils";
import moment from "moment";
import history from "../../utilities/history";
import handSvg from "../../images/hand.svg";
import { CLAIMTYPE } from '../../App.config';

const isAirCaseFound = (allCases) => {
    let isAirCaseFound = false;
    Array.isArray(allCases) && allCases.length > 0 && allCases.map((caseDetail) => {
        if (!isAirCaseFound)
            isAirCaseFound = caseDetail.isAIR ? true : false;
    })
}

const AirCasestatusComponent = (props) => {
    return (
        <>
            {isAirCaseFound(props.allCases) ?
                <div className="Table-list">
                    <div className="Table-head">
                        <div className="Table-cell">
                            <table className="table ">
                                <thead>
                                    <tr>
                                        <th>{props.context.t("CurrentActivity.Name.Text")}</th>
                                        <th>{props.context.t("AIR.DateAirSubmitted.Text")}</th>
                                        <th>{props.context.t("CurrentActivity.nextAction.Text")}</th>
                                        <th>{props.context.t("CurrentActivity.followUpDate.Text")}</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        props.allCases.map((caseDetail, index) => {
                                            return (
                                                <>
                                                    {caseDetail.isAIR ?
                                                        <tr
                                                            className="case-status-tb-row bg-blue"
                                                            onClick={() => props.addRow(index)}
                                                        >
                                                            <td>
                                                                {caseDetail.firstName} {caseDetail.lastName}
                                                            </td>
                                                            <td>
                                                                {caseDetail.dateAIRSubmitted
                                                                    ? utilities.formatDate(
                                                                        caseDetail.dateAIRSubmitted,
                                                                        "MMM DD YYYY"
                                                                    )
                                                                    : "-"}
                                                            </td>
                                                            <td>
                                                                {caseDetail.nextAction ? caseDetail.nextAction : "-"}
                                                            </td>
                                                            <td>
                                                                {caseDetail.followUpDate
                                                                    ? utilities.formatDate(
                                                                        caseDetail.followUpDate,
                                                                        "MMM DD YYYY"
                                                                    )
                                                                    : "-"}
                                                            </td>
                                                            <td>
                                                                <img src={handSvg} height="17" width="17" />
                                                                <button
                                                                    className="case-btn"
                                                                    onClick={() => {
                                                                        history.push("/allcasedetails?ein=" + caseDetail.ein + "&isTableView=true")
                                                                        // let pathname = "/allcasedetails?ein=" + caseDetail.ein;
                                                                        // history.push({
                                                                        //     pathname: pathname,
                                                                        //     state: { isTableView: true }
                                                                        //   });
                                                                    }}
                                                                >
                                                                    Case Details
                                                                </button>
                                                            </td>
                                                        </tr>
                                                        : null}
                                                    {

                                                        (caseDetail.otherData && caseDetail.otherData.isAIR) ? (
                                                            <>
                                                                <tr>
                                                                    <td>{props.context.t("AIR-Employer-Information.form.label.text.Location")}</td>
                                                                    <td>
                                                                        {caseDetail.otherData.location ? caseDetail.otherData.location : "-"}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("ACCOMODATION-Case-Manager.CA")}</td>
                                                                    <td>{caseDetail.otherData.CaseManager ? caseDetail.otherData.CaseManager : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("AIR.DateAirSubmitted.Text")}</td>
                                                                    <td>
                                                                        {caseDetail.otherData.dateAIRSubmitted ? moment(caseDetail.otherData.dateAIRSubmitted).format("MMM DD YYYY") : "-"}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("AIR.OpenOrClosed.Text")}</td>
                                                                    <td>{caseDetail.otherData.isAIRCaseOpen ? "Open" : "Closed"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("AIR.ClaimType.Text")}</td>
                                                                    <td>
                                                                        {CLAIMTYPE[caseDetail.otherData.claimTypeAIR]}
                                                                        {/* {caseDetail.otherData.claimTypeAIR ? caseDetail.otherData.claimTypeAIR : "-"} */}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("AIR.DateOfIncident.Text")}</td>
                                                                    <td>
                                                                        {caseDetail.otherData.dateOfIncident ? moment(caseDetail.otherData.dateOfIncident).format("MMM DD YYYY") : "-"}

                                                                    </td>
                                                                </tr>
                                                                <tr>

                                                                    <td>{props.context.t("AIR.DateOfLostBegan.Text")}</td>
                                                                    <td>
                                                                        {caseDetail.otherData.dateLostTimeBegan ? moment(caseDetail.otherData.dateLostTimeBegan).format("MMM DD YYYY") : "-"}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("AIR.EmployeeReturnToWork.Text")}</td>
                                                                    <td>
                                                                        {caseDetail.otherData.dateEmployeeReturnedToWork ? moment(caseDetail.otherData.dateEmployeeReturnedToWork).format("MMM DD YYYY") : "-"}


                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("AIR.ReturnToWorkStatus.Text")}</td>
                                                                    <td>
                                                                        {caseDetail.otherData.rtwAIRStatus ? caseDetail.otherData.rtwAIRStatus : "-"}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("AIR.FileStatus.Text")}</td>
                                                                    <td>
                                                                        {caseDetail.otherData.airFileStatus ? caseDetail.otherData.airFileStatus : "-"}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("AIR.ClaimStatus.Text")}</td>
                                                                    <td>
                                                                        {caseDetail.otherData.claimStatus ? caseDetail.otherData.claimStatus : "-"}

                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>{props.context.t("AIR.NextActionAndFollowUpDate.Text")}</td>
                                                                    <td>
                                                                        {caseDetail.otherData.airNextAction ? caseDetail.otherData.airNextAction : "-"}
                                                                        {" "}
                                                                        {caseDetail.otherData.followUpDate ? moment(caseDetail.otherData.followUpDate).format("MMM DD YYYY") : "-"}

                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Notes</td>
                                                                    <td>
                                                                        -
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        ) : null
                                                    }

                                                </>
                                            )
                                        })
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> : null}
        </>
    )
}

export default AirCasestatusComponent;